import Store from "./Store";
import Survey from "../../model/survey.model";

export default class SurveyStore extends Store<Survey> {
  protected override name: string = 'surveys';

  public updateRating(survey: Survey, rating: number): void {
    survey.rating = rating;
    this.update(survey).subscribe((updatedSurvey: Survey) => {
      survey.rating = updatedSurvey.rating;
    });
  }
}
